import React from 'react';

export const DEFAULT_PAGE_TITLE = 'Vatix Workspace';

export const formatPageTitle = (name: string): string => `${name} | Vatix`;

export const usePageTitle = (name?: string): void => {
  React.useEffect(() => {
    if (!name) return undefined;
    document.title = formatPageTitle(name);

    return () => {
      document.title = DEFAULT_PAGE_TITLE;
    };
  }, [name]);
};
